






import Vue from 'vue'
import Component from 'vue-class-component'
import Card from '@/components/Card.vue'
import Icon from '@/components/Icon.vue'

@Component({
  components: { Icon, Card }
})
export default class ResidentTabs extends Vue {

}
